<div class="summary-items-loader">
  <layout-skeleton
    *ngFor="let skeleton of skeletonItems"
    [skeleton]="skeleton"
  ></layout-skeleton>
</div>
